import React from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import LeftMenu from '../components/buying/LeftMenu';
import ContactUs from '../components/ContactUs';

const ShippingAndDeliveryProcess = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('buying'),
      url: '/content/buying/before-bidding',
    },
    {
      label: 'Nakliyat ve Teslimat Süreci',
      url: '/content/buying/shipping-and-delivery-process',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <LeftMenu currentPage="shipping-and-delivery-process" />
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">Nakliye ve Teslimat Süreci</h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <p>
                  iyiMakina.com aracılığıyla satılan makinaların, ülke geneli nakliye ve teslimatının iletişimi uzman ekibimiz tarafından koordine edilmektedir.
                  Satıcı ve alıcı arasındaki randevu ve prosedür işlerini gerçekleştirmenizde yanınızdayız.
                </p>
                <p>
                  Nakliyenin gerçekleşmesi ve teslim edilmesi süreci ise alıcının sorumluluğundadır. Satıcı ve iyiMakina.com’un herhangi bir sorumluluğu yoktur.
                  iyiMakina.com, süreç içerisinde alıcı ve satıcının koordine olmasını sağlar.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Hızlı ve Sorunsuz Koordinasyon</h2>
              </div>
              <div className="col-15">
                <p>
                  Ekibimiz alıcı ve satıcı arasındaki tüm iletişimde profesyonel bir yaklaşım göstersin, en sorunsuz şekilde makinanıza sahip olun.
                </p>
              </div>
            </div>
            <ContactUs about="Nakliyat ve Teslimat Süreciyle" />
          </div>
        </div>
      </div>
    </main>
  );
};

ShippingAndDeliveryProcess.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async () => {
  return {
    props: {
      blackHeader: true,
      headTitle: 'Nakliyat ve Teslimat Süreci',
    },
  };
};

ShippingAndDeliveryProcess.Layout = Layout;

export default withTranslation('common')(ShippingAndDeliveryProcess);
